module.exports = __webpack_public_path__ + "img/2061f47.png";